import { DESKTOP_SHARING_STATUS, GRID_VIEW, N_LAST_OPTION } from '../constants';
import type { DesktopSharingStatus } from '../features/screen-sharing/slice';

interface GetSlotsGridPageStepParams {
    desktopSharingStatus: DesktopSharingStatus;
    effectiveGridView: GRID_VIEW;
    maxSlotsCount: number;
}

export const getSlotsGridPageStep = ({
    desktopSharingStatus,
    effectiveGridView,
    maxSlotsCount,
}: GetSlotsGridPageStepParams) => {
    if (effectiveGridView === GRID_VIEW.PRESENTER && desktopSharingStatus === DESKTOP_SHARING_STATUS.NONE) {
        return Math.max(0, maxSlotsCount - N_LAST_OPTION.nCount);
    }

    return maxSlotsCount;
};
